<template>
  <div>

		<x-modal
			width="650"
			v-if="visible == true"
			@cancel="visible = false"
			@close="visible = false"
			@ok="forwardOrReply"
			:draggable="true"
			:resizable="true"
			:loading="loading"
			:okDisabled="!email"
			:okText="forward ? 'Forward Message' : 'Send Message'">

			<div slot="title" :class="`d-flex justify-content-between align-items-center`">
				{{ forward ? 'Forward' : 'Reply' }}
			</div>

			<div class="container">
        <div class="row pt-0 amb-modal-body" style="-ms-overflow-y: auto; overflow-y: auto;">
          <div class="col-12 my-3">
            <div>
              <div v-if="forward" class="input-belt mb-3">
                  <multi-input :model.sync="recipients" label="To"></multi-input>
              </div>
              <div v-if="forward" class="input-belt mb-3">
                <multi-input :model.sync="ccRecipients" label="CC"></multi-input>
              </div>
              <div class="input-belt mb-3">
                <h3 for="email-comments">Message</h3>
                <div class="mt-3 w-100">
                  <summernote :model.sync="editorData" v-if="email"></summernote>
                </div>
              </div>

              <div class="input-belt mb-2" v-if="email">
                <label>Attachments</label>
                <el-select
                  v-model="selectedDocuments"
                  multiple
                  collapse-tags
                  placeholder="Choose Attachments"
                >
                  <el-option-group
                    v-for="(group, index) in docAttachmentDocuments"
                    :key="index"
                    :label="index"
                  >
                    <el-option
                      v-for="docs in group.filter(doc => doc.uploaded)"
                      :key="`${docs.id}-${Number(docs.is_app_document)}`"
                      :label="docs.filename"
                      :value="`${docs.id}-${Number(docs.is_app_document)}`"
                    ></el-option>
                  </el-option-group>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
		</x-modal>
  </div>
</template>

<script>
import _ from 'underscore'

export default {
  components: {},
  props: {
    applicationId: {
      required: true,
      type: Number
    },
    open: {
      type: Boolean,
      required: true
    },
    emailId: {
      type: Number,
      required: true
    },
    forward: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      visible: false,
      selectedTemplate: null,
      email: null,
      selectedDocuments: [],
      templates: [],
      editorData: "",
      docDocuments: [],
      recipients: '',
      ccRecipients: '',
			loading: false,
      headers: {
        headers: {
          Authorization: `Bearer ${this.$store.getters.token}`
        }
      }
    };
  },
  deactivated() {
  },
  mounted() {
    this.getDocuments();
    // this.getTemplates();
  },
  methods: {
		forwardOrReply() {
			this.forward ? this.forwardMessage() : this.sendMessage();
		},
    async getTemplates() {
      try {
        let res = await axios.get(
          "/api/settings/email_templates",
          this.headers
        );

        this.templates = res.data;
      } catch (err) {
        console.error(err);
      }
    },
    async getDocuments() {
      try {
        let res = await axios.get(
          "/api/application/" + this.applicationId + "/finalise/documents",
          this.headers
        );
        this.docDocuments = res.data.documents; // migrate this
      } catch (err) {
        console.error(err);
      }
    },

    /**
     * Format all attachments before sending to server
     *
     * 1. Attachments from existing email will be POSTed as object.
     * 2. Document attachments will continue to be POSTed as an id string.
     */
    formatAttachments() {
      const docAttachmentDocuments = _.flatten(Object.values(this.docAttachmentDocuments))

      const attachments = this.selectedDocuments.map((id, i) => {
        const emailAttachment = docAttachmentDocuments.find((e) => e.attachment_id === id)
        if (emailAttachment) return emailAttachment
        return id
      })

      return attachments
    },

    async forwardMessage(){
      const attachments = this.formatAttachments()
			this.loading = true;

      try {
        let res = await axios.post(
          `/api/v2/emails/${this.emailId}/forward`,
          {
            recipients: this.recipients,
            ccRecipients: this.ccRecipients,
            body: this.editorData,
            template: this.selectedTemplate,
            attachments
          },
          this.headers
        );

        if (res.data) {
          this.visible = false;
          this.$message({
            message: "Message Forwarded",
            type: "success"
          });
					this.loading = false;
        }
      } catch (error) {
        console.error(error);
        this.$message({
          message: "Cannot Forward Message",
          type: "error"
        });
				this.loading = false;
      }
    },
    async sendMessage() {
      const attachments = this.formatAttachments()
			this.loading = true;


      try {
        let res = await axios.post(
          `/api/v2/emails/${this.emailId}/reply`,
          {
            body: this.editorData,
            template: this.selectedTemplate,
            attachments
          },
          this.headers
        );

        if (res.data) {
          this.visible = false;
          this.$message({
            message: "Message Sent",
            type: "success"
          });
					this.loading = false;
        }
      } catch (error) {
        console.error(error);
        this.$message({
          message: "Cannot Send Message",
          type: "error"
        });
				this.loading = false;
      }
    },
    async getEmail() {
      try {
        let res = await axios.get(
          `/api/v2/emails/${this.emailId}?forward=${this.forward}`,
          this.headers
        );

        this.email = res.data;

        if(this.forward){
          let emailSent = this.$moment(
              new Date(this.email.created_at)
          ).format("LLLL");

          let emailBody = "<br/><br/><br/><br/><p style='border-top: 1px solid #555555; padding-top: 15px;'>---------- Forwarded message ---------<br/>"+
                "From: "+this.email.from+"<br/>"+
                "Sent: "+emailSent+"<br/>"+
                "To: "+this.email.to+"<br/>";
                if(this.email.cc != null && this.email.cc != '[]')
                  emailBody += "Cc: "+this.email.cc+"<br/>";
                emailBody += "Subject: "+this.email.subject+"</p><br/><br/>"+
                this.email.body;

          this.editorData = emailBody;
          this.selectedDocuments = this.email.attachments.map((e) => {
            return `${e.id}-0`
          })

        }else{
          this.editorData = this.email.body;
          this.selectedDocuments = []
        }

      } catch (err) {
        console.error(err);
      }
    }
  },
  watch: {
    visible(newVal, oldVal) {
      this.$emit("update:open", newVal);
    },
    open(newVal, oldVal) {
      this.visible = newVal;
      if (newVal) {
        this.getEmail();
      } else {
        this.email = null;
      }
    }
  },
  computed: {
    docAttachmentDocuments(){
      var thisDocAttachments = {};
      var docAttachments = {};

      this.docDocuments.forEach(item => {
        var cat = item.doc_category;
        if(cat == null || cat == 'fls') cat = 'customer';
          if(docAttachments[cat] === undefined)
            docAttachments[cat] = [];

          docAttachments[cat].push(item);
      });

      if(docAttachments.customer !== undefined) thisDocAttachments['CUSTOMER DOCUMENTS'] = docAttachments.customer;
      if(docAttachments.internal !== undefined) thisDocAttachments['INTERNAL DOCUMENTS'] = docAttachments.internal;
      if(docAttachments.bank !== undefined) thisDocAttachments['LENDER DOCUMENTS'] = docAttachments.bank;
      if(docAttachments.backend !== undefined) thisDocAttachments['UPLOADED DOCUMENTS'] = docAttachments.backend;
      if(docAttachments.seller !== undefined) thisDocAttachments['SELLER DOCUMENTS'] = docAttachments.seller;

      // Add selected email documents to list as well
      thisDocAttachments['CURRENT EMAIL'] = this.email.attachments.map((e, i) => {
        return Object.assign(e, {
          // id: `${e.id}-0`,
          attachment_id: `${e.id}-0`,
          uploaded: true,
          email_attachment: true,
          is_app_document: false,
          filename: e.name
        })
      })
      //

      return thisDocAttachments;
    }
  }
}
</script>

